





















































































import AdUnit from "@/models/adUnit";
import { LineItem } from "@/models/campaign";
import { CampaignReportData } from "@/models/CampaignReport";
import { DefinitionBatch } from "@/models/definition";
import Site from "@/models/site";
import { get } from "lodash";
import moment from "moment";
import { Component, Vue, Prop } from "vue-property-decorator";
import LineItemReport from "./LineItemReport.vue";
@Component({
  components: {
    LineItemReport,
  },
})
export default class CampaignReportDetail extends Vue {
  @Prop() loading!: boolean;
  @Prop() data!: CampaignReportData;
  @Prop() definitions!: DefinitionBatch[];
  @Prop() sites!: Site[];
  @Prop() adUnits!: AdUnit[];
  @Prop() lineItems!: LineItem[];

  lineItem: LineItem | null = null;

  getSite(id: string): string {
    const site = this.sites.find((e) => e.id === id);
    return site ? site.name : "";
  }

  getAdUnit(id: string): string {
    const adUnit = this.adUnits.find((e) => e.id === id);
    return adUnit ? adUnit?.name : "";
  }

  getDefinition(id: string): string {
    let definition;
    this.definitions.forEach((e) => {
      const value = e.values.find((d) => get(d, "id") === id);
      value ? (definition = value) : null;
    });
    return definition ? get(definition, "name") : "";
  }

  onSelect(id: string): void {
    const lineItem = this.lineItems.find((l) => l.id === id);

    lineItem ? (this.lineItem = lineItem) : null;
  }

  formatDate(date: string): string {
    return moment(date).format("DD-MM-YYYY");
  }
}
